import ContainerFactory from './container_factory'
export default ContainerFactory



// WEBPACK FOOTER //
// ./src/components/container_factory/index.js